import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { Denuncia } from "../denuncia/denuncia";
import { DenunciasService } from "./denuncias.service";

import { AuthAndACLService } from "../auth_and_acl/authAndACL.service";
import { Usuario } from "../usuario/usuario";

@Component({
  selector: "app-denuncias-finalizadas",
  templateUrl: "./denuncias-finalizadas.component.html",
  styleUrls: ["./denuncias-finalizadas.component.css"],
  providers: [
    DenunciasService
  ]
})
export class DenunciasFinalizadasComponent implements OnInit {
  public usuario: Usuario;

  denuncias: Denuncia[];

  denuncia: Denuncia;

  imgListEntrevista = "../../assets/img/listicon.png";

  imgVerIncidente = "../../assets/img/viewicon.png";

  imgVerResumo = "../../assets/img/searchicon.png";

  imgVerEncaminhamento = "../../assets/img/eyeicon.png";

  


  constructor(
    private denunciaService: DenunciasService,
    public  authAndACL: AuthAndACLService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.denuncia = new Denuncia();
  }

  getDenuncias(): void {
    this.denunciaService.getDenunciasFinalizadas().then(denuncia => {
      this.denuncias = denuncia;
    });
  }

  ngOnInit() {
    this.getDenuncias();
  }
}



// WEBPACK FOOTER //
// ./src/app/denuncias/denuncias-finalizadas.component.ts